import 'react-app-polyfill/stable';

export async function loadPolyfills(): Promise<void> {
  if (!String.prototype.normalize) {
    // eslint-disable-next-line node/no-unsupported-features/es-syntax
    await import('unorm');
  }
}
